import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { emptyMinimizerData, removeMinimizerData } from "../../reducers/minimizerFloatter";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { addRedirectParam } from "@Helpers";
import { Box } from "@mui/material";
import IconComponent from "@CubeComponents/icons";
export function MinimizeFloatter() {
  const { t } = useTranslation();
  const [dropDownState, setDropDownState] = useState(false);
  const minimizeFloatterData = useSelector((state: any) => state.minimizeFloatterData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ref = useRef<any>(null);

  const handler = (event: any) => {
    if (!ref.current?.contains(event.target)) {
      setDropDownState(false);
    }
  };

  useEffect(() => {
    handler(null as any);
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  const handleRemoveIcon = () => {
    dispatch(emptyMinimizerData());
  };

  const handleSelectItem = (event: any) => {
    const index = event.currentTarget.attributes["data-set"].value;
    const urlWithUpdatedRedirect = addRedirectParam({
      targetPath: new URL(minimizeFloatterData[index].path, globalThis.location.origin),
      redirectTo: globalThis.location,
    });
    navigate(urlWithUpdatedRedirect);
    dispatch(removeMinimizerData(minimizeFloatterData[index].index));
  };

  const removeSelectItem = (index: any) => {
    dispatch(removeMinimizerData(minimizeFloatterData[index].index));
  };

  const changeState = () => {
    setDropDownState((prevState) => !prevState);
  };

  return (
    <>
      {minimizeFloatterData.length ? (
        <div
          ref={ref}
          className="absolute z-10"
          style={{
            bottom: "calc(36px / var(--aspect-ratio-3))",
            insetInlineEnd: "2.25rem",
          }}
        >
          {dropDownState ? (
            <div
              className="flex flex-col overflow-x-hidden rounded border border-[var(--primary-blue)] bg-gradient-to-b from-white to-[#f0f5f9] shadow-[4px_4px_15px_0_rgba(65,92,171,0.15)]"
              style={{
                width: "18.75rem",
                maxHeight: "calc(300px / var(--aspect-ratio-1-dot-2))",
                marginBottom: "0.9375rem",
                marginInlineEnd: "1.25rem",
              }}
            >
              <div
                className="sticky top-0 flex flex-row items-center bg-[#f0f5f9]"
                style={{
                  height: "3.75rem",
                  width: "18.75rem",
                  gap: "7.5rem",
                }}
              >
                <span className="mt-5 text-lg text-[#192638] ms-6">{t("Open Files")}</span>
                <Box className="mt-[1.625rem] cursor-pointer text-xs text-[#3e8ab0]" onClick={handleRemoveIcon}>
                  <strong>{t("Close All")}</strong>
                </Box>
              </div>
              {minimizeFloatterData.map((props: any, index: any) => (
                <div key={index} className="flex items-center bg-white overflow-auto hover:bg-[#caecff]">
                  <div className="flex-1 mt-1 ms-5">
                    <IconComponent name="FileDWG" />
                  </div>
                  <Box className="flex flex-row items-start flex-[4]" onClick={handleSelectItem} data-set={index}>
                    <p className="mt-2 mb-2.5 flex-1 break-all">{props.text}</p>
                  </Box>
                  <div className="flex-1">
                    <IconComponent
                      name="close"
                      data-set={index}
                      onClick={() => removeSelectItem(index)}
                      className="h-2.5 w-2.5"
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          <IconComponent
            name="cube_img"
            className="h-13 w-13"
            onClick={changeState}
            parentContainerClass="relative float-end !p-0 !min-w-0 !rounded-none"
          />
        </div>
      ) : null}
    </>
  );
}

export default MinimizeFloatter;
